// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"3b6b697c","821":"b10ce069"}[chunkId] + ".chunk.css";
};